<template>
  <div id="app">
    <img
      src="./assets/images/default-js.png"
      id="avatar"
      style="display:none;"
    />
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    let data = null;
    const isLogin = this.$cookies.get('_IsLogin');
    if (isLogin === null) {
      data = localStorage.getItem('CurrentUser');
    } else if (isLogin === '0') {
      localStorage.removeItem('Authorization');
      localStorage.removeItem('CurrentUser');
      location.href = `${
        process.env.VUE_APP_PASSPORT_LOGINURL
      }?returnUrl=${encodeURIComponent(location.href)}`;
    }
    if (isLogin !== null) {
      this.$cookies.remove('_IsLogin', '/', process.env.VUE_APP_Domain);
    }
    if (data === null) {
      this.getUserInfo();
    } else {
      try {
        const user = JSON.parse(data);
        if (Object.prototype.toString.call(user) === '[object Object]') {
          this.$store.dispatch('setUserInfo', user);
        } else {
          this.getUserInfo();
        }
      } catch {
        this.getUserInfo();
      }
    }
    this.online();
  },
  methods: {
    async getUserInfo() {
      const response = await this.$api.user.getUserInfo();
      const data = response.data.data;
      if (data) {
        this.$store.dispatch('setUserInfo', data);
        localStorage.setItem('CurrentUser', JSON.stringify(data));
      }
    },
    async online() {
      await this.$api.user.online();
      setTimeout(this.online, 60000);
    },
  },
};
</script>
